<script>
import i18nMixin from '@/mixins/i18n.mixin.js';
import { h, resolveComponent } from 'vue';

const FLEX_GAP = 40;

export default {
  name: 'cFilter',
  mixins: [i18nMixin],
  emits: ['reset', 'search'],
  props: {
    schema: {
      type: Object,
      default: () => {}
    },
    model: {
      type: Object,
      default: () => {}
    },
    cols: {
      type: Number,
      default: 1
    },
    resetText: {
      type: String,
      default: null
    },
    searchText: {
      type: String,
      default: null
    },
    labelWidth: {
      type: String,
      default: undefined
    },
    disableSearch: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    reset() {
      this.$emit('reset');
    },
    setValue() {
      this.$nextTick(() => {
        Object.keys(this.model).forEach((key) => {
          if (this.$refs[key] && ['string', 'number', 'null'].includes(typeof this.model[key]))
            this.$refs[key].txtField = this.model[key].replace(/\s{2,}/gi, ' ').trim();
        });
      });
    },
    search() {
      this.setValue();
      this.$emit('search', this.model);
    },
    changeInput(item, value) {
      this.model[item.model] = value;
      if (item.onChange) {
        item.onChange(item, value);
      }
    },
    getIcon(item, value) {
      if (item.onGetIcon) {
        item.onGetIcon(value);
      }
    },
    calColWidth() {
      return ((this.cols - 1) * FLEX_GAP) / this.cols;
    }
  },
  computed: {
    setLabelWidth() {
      if (this.labelWidth) {
        return this.labelWidth;
      } else if (this.cols === 2 || this.cols === 1) {
        return 170;
      } else if (this.cols === 3) {
        return 130;
      } else if (this.cols === 4) {
        return 110;
      } else if (this.cols === 5 || this.cols > 5) {
        return 84;
      } else {
        return undefined;
      }
    }
  },
  render() {
    const { model, cols, schema, setLabelWidth } = this;
    const legoIcon = resolveComponent('lego-icon');
    const legoTooltip = resolveComponent('lego-tooltip');
    const scpmTreeDropdown = resolveComponent('scpm-tree-dropdown');
    const scpmDropdownV3 = resolveComponent('scpm-dropdown-v3');
    const legoMultiDropdown = resolveComponent('lego-multi-dropdown');
    const legoDropdown = resolveComponent('lego-dropdown');
    const legoTextField = resolveComponent('lego-text-field');
    const legoDropdownCheckExtend = resolveComponent('lego-dropdown-check-extend');
    const legoButton = resolveComponent('lego-button');

    const arrMultiSelect = [
      'agentType',
      'disableYn',
      'productName',
      'productIdList',
      'metricKeyList'
    ];

    const fieldHelp = (field) =>
      field.help &&
      h('span', { class: 'help' }, [
        h(legoIcon, {
          iconType: 'df',
          icon: 'info',
          size: 16,
          id: 'manual'
        }),
        h(legoTooltip, { top: true, mouseOver: true }, [field.help])
      ]);

    const fieldLabel = (field) =>
      h(
        'div',
        {
          class: 'search-form-label',
          style: {
            width: '100%'
          }
        },
        [field.label, field.required && h('span', { class: 'required' }, ['*']), fieldHelp(field)]
      );

    const fieldContent = (item) => {
      return h(
        'div',
        {
          class: [{ 'search-form-content': true }]
        },
        [
          item.type === 'tree-select' &&
            h(scpmTreeDropdown, {
              selectAll: item.multi && true,
              selectAllText: item.multi && item.selectAllText,
              items: item.values,
              modelValue: model[item.model],
              disabled: item.disabled,
              class: item.fieldClasses,
              width: item.width,
              placeholder: item.placeholder || 'Nothing selected',
              'onUpdate:modelValue': (value) => this.changeInput(item, value),
              onGetIcon: (value) => this.getIcon(item, value),
              ref: item.id,
              style: { width: typeof item.width === 'number' ? item.width + 'px' : item.width }
            }),
          item.type === 'select' &&
            h(item.multi
                ? (item.multiSelect ? scpmDropdownV3 : legoMultiDropdown)
                : legoDropdown, {
              hasSearchField: item.hasSearchField,
              selectAll: item.multi && true,
              selectAllText: item.multi && item.selectAllText,
              items: item.values,
              showOnlyKey: true,
              modelValue: model[item.model],
              disabled: item.disabled,
              isTarget: item.isTarget,
              isChangeTextShow: arrMultiSelect.includes(item.id),
              isStaticType: item.isStaticType,
              class: item.fieldClasses,
              width: item.width,
              placeholder: item.placeholder || 'Nothing selected',
              itemWidth: '100%',
              'onUpdate:modelValue': (value) => this.changeInput(item, value),
              ref: item.id,
              style: { width: typeof item.width === 'number' ? item.width + 'px' : item.width }
            }),
          item.type === 'input' &&
            h(legoTextField, {
              rules: item.validate,
              modelValue: model[item.model],
              textarea: item.textarea,
              class: item.fieldClasses,
              disabled: item.disabled,
              clearable: !item.textarea || false,
              maxlength: item.maxlength,
              counter: item.counter || item.maxlength,
              multiple: item.multiple,
              name: item.inputName,
              placeholder: item.placeholder,
              readonly: item.readonly,
              required: item.required,
              rows: item.rows,
              width: item.width,
              messageStyle: 'light',
              mutateInput: item.mutateInput,
              isCounter: item.isCounter,
              'onUpdate:modelValue': (value) => this.changeInput(item, value),
              onKeyup: (value) => {
                if (value.key === 'Enter') {
                  this.search();
                }
              },
              ref: item.id,
              style: { width: typeof item.width === 'number' ? item.width + 'px' : item.width }
            }),
          item.type === 'input-search' &&
            h(
              legoDropdownCheckExtend,
              {
                items: item.values,
                modelValue: model[item.model],
                disabled: item.disabled,
                class: item.fieldClasses,
                width: item.width,
                placeholder: item.placeholder || 'Nothing selected',
                mutateInput: item.mutateInput,
                ref: item.id,
                style: [{ width: typeof item.width === 'number' ? item.width + 'px' : item.width }]
              },
              ()=> [item]
            ),
          item.slotName && this.$slots[item.slotName]()
        ]
      );
    };

    const fieldGroup = (group) => {
      return h(
        'div',
        {
          class: 'search-form-group'
        },
        [
          group.map((item) => {
            return fieldContent(item);
          })
        ]
      );
    };

    let num = 0;
    const form = h(
      'div',
      {
        class: 'search-form'
      },
      [
        schema.fields.map((item, index) => {
          if (item.isShow !== undefined && !item.isShow) {
            return;
          }

          const fieldPercent = 100 / cols;
          num += item.col || 1;

          return h(
            'div',
            {
              class: {
                'search-form-field': true
              },
              style: {
                width: item.col
                  ? fieldPercent * item.col + '%'
                  : `calc(${fieldPercent}% - ${this.calColWidth()}px)`,
                paddingRight: num % cols === 0 ? 0 : '70px'
              }
            },
            [fieldLabel(item), item.group ? fieldGroup(item.group) : fieldContent(item)]
          );
        })
      ]
    );

    const buttons = h(
      'div',
      {
        class: 'button-group'
      },
      [
        h(
          legoButton,
          {
            onClick: this.reset
          },
          () => [this.resetText || this.t('button.reset')]
        ),
        h(
          legoButton,
          {
            main: true,
            disabled: this.disableSearch,
            onClick: this.search
          },
          () => [this.searchText || this.t('button.search')]
        )
      ]
    );

    return h(
      'div',
      {
        class: { 'c-filter': true }
      },
      [form, buttons]
    );
  }
};
</script>

<style lang="scss" scoped>
.c-filter {
  .search-form {
    display: flex;
    flex-wrap: wrap;
    background-color: $color--primary-tint01;
    padding: 24px;
    gap: 16px 40px;
    border-radius: 4px;

    &-label {
      min-width: 32px;
      line-height: 16px;
      font-weight: 700;
      margin-bottom: 8px;
      color: $color--ui-01;

      .required {
        color: $color--status--error;
        margin-left: 2px;
        font-weight: 700;
        font-size: 14px;
        margin-left: 4px;
      }

      .help {
        vertical-align: middle;
        margin-left: 5px;
      }
    }

    &-content {
      flex: 1;
      min-width: 0;

      .lego-dropdown,
      .lego-text-field {
        min-width: auto;
      }
    }

    &-group {
      flex: 1;
      min-width: 0;
      display: flex;

      .search-form-content {
        & + .search-form-content {
          margin-left: 8px;
        }
      }
    }
    .search-form-field{
      .search-form-content {
        width: 100%;
      }
    }
  }

  .button-group {
    text-align: right;
    padding: 16px 0;
    border-bottom: 1px solid #e4e5e7;
  }
}
</style>
